"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BuildTransactionRequestType;
(function (BuildTransactionRequestType) {
    BuildTransactionRequestType["TRANSFER"] = "TRANSFER";
    BuildTransactionRequestType["GAS_TRANSFER"] = "GAS_TRANSFER";
    BuildTransactionRequestType["TOKEN_TRANSFER"] = "TOKEN_TRANSFER";
    BuildTransactionRequestType["NFT_TRANSFER"] = "NFT_TRANSFER";
    BuildTransactionRequestType["CONTRACT_EXECUTION"] = "CONTRACT_EXECUTION";
})(BuildTransactionRequestType = exports.BuildTransactionRequestType || (exports.BuildTransactionRequestType = {}));
//# sourceMappingURL=BuildTransactionRequestType.js.map